import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Caption.module.css';

export default class Caption extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        isLarge: PropTypes.bool,
        isRequired: PropTypes.bool,
        isError: PropTypes.bool,
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isLarge]: this.props.isLarge,
            [styles.isRequired]: this.props.isRequired,
            [styles.isError]: this.props.isError,
        })

        return (
            <div className={classNameBase}>{this.props.children}</div>
        )
    }
}
